import api from "./api.js";
import qs from "qs";
// 根据sdCode获取全部KeyValue
// export async function getValue(sdCode) {
// 	return await api.get('sysdictionnary/keyValue2?Code=' + sdCode);
// }
// 获取学校列表
export async function getSchool(data) {
  return await api.get("School/Index", data);
}
// 获取所有学校简短数据
export async function getAllSchool() {
  return await api.get("School/All");
}
// 根据专业和城市获取学校列表
export async function getSpeciality(data) {
  return await api.get("School/Speciality", data);
}
// 获取学校详情
export async function SchoolDetails(sdid) {
  return await api.get("School/GetModel?SDID=" + sdid);
}

// 获取高校排名
export async function getSchoolDetails(data) {
  return await api.get("SchoolDetails/Index", data);
}

// 获取所有城市
export async function getAllCtiy(parentid) {
  return await api.get("citys/allChildren?parentId=" + parentid);
}

// 通知公告列表
export async function notice(data) {
  return await api.get("bulletin/Index", data);
}

// 通知公告详情
export async function getbulletinDetails(id) {
  return await api.get("bulletin?bId=" + id);
}

// 专业
export async function majorIndex(data) {
  return await api.get("ShSpeciality/Index", data);
}
export async function getAllMajor(data) {
  return await api.get("sysspeciality/Index", data);
}
// 专业详情
export async function getMajorSlid(SLID) {
  return await api.get("ShSpeciality?SLID=" + SLID);
}
// 系统专业详情
export async function getSysspecialityGetModel(SLID) {
  return await api.get("sysspeciality/GetModel?SLID=" + SLID);
}

// 专业下招生计划
export async function getRecruitPlanList(data) {
  return await api.get("specialityRecruitPlan/Index", data);
}

// 学校荣誉
export async function getShHonorsList(data) {
  return await api.get("ShHonors/Index", data);
}

// 学校留言查询
export async function getShOnlineConsultation(data) {
  return await api.get("ShOnlineConsultation/Index", data);
}

// 发送留言
export async function postShOnlineConsultation(data) {
  return await api.post("ShOnlineConsultation", data);
}

//根据试卷id 获取试题集合
export async function getExamination(tid) {
  console.log("打印tid", tid);
  return await api.get("QTestPaperSet/detail?tId=" + tid);
}

//查询我的评测记录
export async function getMyreport(data) {
  return await api.get("QPaperResult", data);
}
//提交试卷接口
export async function submitReport(data) {
  let content = {
    content: "application/json"
  };
  return await api.post("QPaperResult", data, content);
}
//查询我的评测报告
export async function getMyreportInfo(prId) {
  return await api.get("QPaperResult/GetGenerateReport?prId=" + prId);
}
//获取收费功能的信息集合
export async function getChargeInfo(bType) {
  return await api.get("bulletin/GetListMoney?bType=" + bType);
}

// 用户登录
export async function phoneLogin(data) {
  return await api.post("userLogin/phoneLogin", data);
}

// 获取验证码
export async function verificationCode(data) {
  return await api.post("studentLogin/verificationCode", data);
}

//注册
export async function signin(data) {
  return await api.post("studentLogin/signin", data);
}

// 密码登录
export async function studentLogin(data) {
  return await api.post("studentLogin/login", data);
}

//验证码登录
export async function codeLogin(data) {
  return await api.post("studentLogin/codeLogin", data);
}
export async function phoneNumber(loginAccount) {
  return await api.get("studentLogin/phoneNumber?loginAccount=" + loginAccount);
}

//创建支付订单
export async function creatOrder(data) {
  let content = {
    content: "application/json"
  };
  return await api.post("CmCostPay", data, content);
}

//根据sdCode查询字典档
export async function getValue(sdCode, parentid) {
  //查询子类
  if (parentid) {
    return await api.get(
      "sysdictionnary/keyValue/" + sdCode + "?parentid=" + parentid
    );
  } else {
    //查询父类
    return await api.get("sysdictionnary/keyValue/" + sdCode);
  }
}

//根据id获取单个课时详细信息
export async function getExitMd5(Id) {
  return await api.get("ossUpload/exist/" + Id);
}

//请求获取token
export async function getToken(path, pType) {
  return await api.get(`ossUpload/token?path=${path}&pType=${pType}`);
}

//上传成功时调用
export async function successToSys(data) {
  return await api.post(`ossUpload/file`, qs.stringify(data));
}

//删除时调用
export async function deleteFormSys(md5) {
  return await api.del(`ossUpload/single/md5/${md5}`);
}

//编辑时 删除oss文件
export async function deleteOssFile(ids) {
  return await api.del(`ossUpload/deleteByfrId/${ids}`);
}

//上传问卷调查 (调用的新闻接口 )
export async function addBulletin(data) {
  let obj = {
    content: "application/problem+json; charset=utf-8"
  };
  return await api.post(`bulletin`, data, obj);
}

//----------------2024-06-11 新增
//添加学生报名
export async function postStudentRegistration(data) {
  let obj = {
    content: "application/problem+json; charset=utf-8"
  };
  return await api.post("studentRegistration", data, obj);
}
//查询报名学生状态(传入userName和idCardNumber两个参数查询某人)
export async function getStudentRegistration(QueryParams, data) {
  return await api.get(
    "studentRegistration/Index?queryParams=" + QueryParams,
    data
  );
}
//编辑学生报名
export async function putStudentRegistration(data) {
  let obj = {
    content: "application/problem+json; charset=utf-8"
  };
  return await api.put("studentRegistration", data, obj);
}
//删除学生报名
export async function deleteStudentRegistration(srId) {
  let form = {
    Datas: [srId]
  };
  let obj = {
    content: "application/problem+json; charset=utf-8"
  };
  return await api.del(`studentRegistration`, form, obj);
}

// // 查询
// export async function getbiddingProject(data,QueryParams) {
// 	return await api.get('biddingProject?queryParams=' + QueryParams,data);
// }
// // 新增
// export async function postproduct(data,res) {
// 	return await api.put('product',data);
// }
// // 修改
// export async function putproduct(data,res) {
// 	return await api.put(`product/${res}`,data);
// 	// return await api.put('product/' + res,data);
// }
// // 删除
// export async function delproduct(res) {
// 	return await api.del('product?pIds=' + res);
// }



// WEBPACK FOOTER //
// ./src/api/index.js